


















































































































import Vue from "vue";
import Component from "vue-class-component";
import DownlinksQueueSection from "@/components/device/DownlinksQueueSection.vue";
import {Prop} from "vue-property-decorator";
import {Device, DeviceBusEventData, DeviceConfigurationSet} from "@/types/core";
import {curDeviceService} from "@/services/DeviceService";
import _ from "lodash";
import {nsenDeviceConfigurationProfile} from "@/components/device/configuration/nsen/NsenProfile";
import GenericControl from "@/components/device/configuration/GenericControl.vue";
import {ConfigurationProfileHelper} from "@/components/device/configuration/ConfigurationProfileHelper";
import KeyValue from "@/components/KeyValue.vue";
import EditableInput from "@/components/EditableInput.vue";
import EditableSelect from "@/components/EditableSelect.vue";
import ExpandButton from "@/components/ExpandButton.vue";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import ToggleInput from '@/components/shared/ToggleInput.vue';

@Component({
  components: {
    KeyValue,
    EditableInput,
    EditableSelect,
    DownlinksQueueSection,
    ExpandButton,
    GenericControl,
    ConfirmDialog,
    ToggleInput
  },
})
export default class NsenControl extends GenericControl {
  @Prop({ default: () => {}, type: Object}) device!:Device;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  private httpBusy:boolean = false;
  private error:string = '';
  
  configurationProfileHelper = new ConfigurationProfileHelper(nsenDeviceConfigurationProfile);
  currentConfiguration = this.configurationProfileHelper.getDeviceUIConfiguration();
  newConfiguration = this.configurationProfileHelper.getDeviceUIConfiguration();
  section = this.configurationProfileHelper.getUISections();
  disableUpdateConfig = true;


  created() {
    this.bus.$on('refresh-device', async (deviceBusEventData:DeviceBusEventData) => {
      await this.loadCurrentConfiguration();
    });
  }
  async mounted() {
    await this.loadCurrentConfiguration();
    _.forEach(_.keys(this.section), index => {
      this.section[index].expanded = true;
    });

    // some configs from previous sessions may have yet to be pushed to the device
    this.onConfigChange();
  }

  async loadCurrentConfiguration() {
    try {
      const reply = await curDeviceService.loadDeviceConfiguration({deviceId: this.device.deviceId}) as DeviceConfigurationSet;

      try {
        if (reply.current) {
          _.forEach(reply.current, param => {
            this.currentConfiguration[this.toHex(param.id)] = {
              id: param.id,
              value: param.value,
              edit: true,
            };
            this.newConfiguration[this.toHex(param.id)] = {
              id: param.id,
              value: param.value,
              edit: true,
            };
          });
        }
      } finally {
      }

      try {
        if (reply.newConf && reply.newConf.length > 0) {
          _.forEach(reply.newConf, param => {
            this.newConfiguration[this.toHex(param.id)] = {
              id: param.id,
              value: param.value,
              edit: true,
            };
          });
        }
      } finally {
      }
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  updateOption(id: string, value: string) {
    this.newConfiguration[id]!.value = value;
  }


  cancel() {
    this.$emit('close');
  }

  async resetDevice() {
    this.error = '';
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'restart',
        params: [{
          id: 0,
          value: Math.floor(Math.random() * 256),
        }]
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async showConfirmResetAccumulatedTotals() {
    (this.$refs.confirmResetAccumulatedTotals as ConfirmDialog).show(this.resetAccumulatedTotals);
  }
 
  async resetAccumulatedTotals() {
    this.error = '';
    try {
      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'pulrst',
        params: [{
          id: 0,
          value: Math.floor(Math.random() * 256),
        }]
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async updateConfiguration() {
    this.error = '';
    const formInvalid = _.some(_.keys(this.newConfiguration), id => ! this.isValueInRange(id, this.newConfiguration));
    if (formInvalid) {
      this.error = 'Some values on the form are invalid. Please fix them before submitting !';
      return;
    }

    const paramKeysToUpdate = await this.getChangedParams();

    if (paramKeysToUpdate.length > 0) {
      const params = _.map(paramKeysToUpdate, key => _.pick(this.newConfiguration[key]!, 'id', 'value'));

      await curDeviceService.sendDeviceCommand({
        deviceId: this.device.deviceId,
        command: 'p1',
        params: [{
          id: 0,
          value: Math.floor(Math.random() * 256),
          ignoreUpdateConfiguration: true,
        }, {
          id: 145,
          value: 150,
          ignoreUpdateConfiguration: true,
        }]
      });

      await Promise.all(_.map(params, param => {
        const profile = nsenDeviceConfigurationProfile[`0x${param.id.toString(16)}`];
        return curDeviceService.sendDeviceCommand({
          deviceId: this.device.deviceId,
          command: (profile && profile.command) ? profile.command : 'p2',
          params: [{
            id: 0,
            value: Math.floor(Math.random() * 256),
            ignoreUpdateConfiguration: true,
          }, {
            id: param.id,
            value: param.value,
          }],
        });
      }));

      this.bus.$emit('refresh');
    }
  }

    async getChangedParams(): Promise<string[]> {
      const paramKeysToUpdate = _.filter(_.keys(this.newConfiguration), (key) => {
        if (this.currentConfiguration[key] === undefined) {
          return false;
        }

        const currConfigValue = this.currentConfiguration[key]!.value;
        const newConfigValue = this.newConfiguration[key]!.value;

        if (Array.isArray(newConfigValue)) {
          return Boolean(
            newConfigValue.some((x: string) => {
              if (currConfigValue) {
                return !currConfigValue.includes(x);
              }
              return true;
            })
          );
        }
        if (typeof newConfigValue === "string" && typeof currConfigValue === "object") {
          return (newConfigValue !== "" && newConfigValue !== currConfigValue.value);
        }

        return newConfigValue !== currConfigValue;
      });

      return paramKeysToUpdate;
    }

    async onConfigChange() {
      this.getChangedParams().then((params) => {
        this.disableUpdateConfig = !(params.length > 0);
      });
    }
}
